import { withCommonPreloads } from './commons/commonPreloads';
import commonPlainFaresPreload from './commons/commonPlainFaresPreload';

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(commonPlainFaresPreload, cmpConfig, 'initialDestinationCards');
};

export default preloadCustomProps;
